import axios from 'axios'

// var callback;

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value,
    }
  }
}

function getListVoucher(pagination, search, callback)
{
  var config = getConfig()
  // if(params) config.params = params[0]
  var url = '/sales/vouchers?'

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  }
  if (search && search.product_id) url += '&product_id=' + search.product_id
  if (search && search.channel_id) url += '&channel_id=' + search.channel_id
  http.get(url, config).then((response) => {
    callback({
      success: true,
      data: response.data,
      pagination: {
        page: response.headers['pagination-page'],
        limit: response.headers['pagination-limit'],
        total_page: response.headers['pagination-total-pages'],
        total_data: response.headers['pagination-total-elements']
      }
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}

function getListChannels(pagination, search, callback)
{
  var config = getConfig()
  // if(params) config.params = params[0]
  var url = '/sales/channels'

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  //   url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.message
    })
  })
}
function generateVoucher(dataBody, callback)
{
  var config = getConfig()

  http.post('/sales/voucher', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.message
      })
    })
}



export default
{
    getListVoucher,
    getListChannels,
    generateVoucher
//   addBimbel,
//   deleteBimbel,
//   editBimbel,
//   publishBimbel,

}



// WEBPACK FOOTER //
// ./src/services/voucher.js